import { createFileRoute } from "@tanstack/react-router";
import { AdminPage } from "@/components/admin/AdminSidebar";
import { TramitesPanel } from "@/components/admin/TramitesPanel";

export const Route = createFileRoute("/admin/tramites")({
  head: () => ({ meta: [{ title: "Trámites — Bizaclia" }] }),
  component: () => (
    <AdminPage title="Trámites" description="Solicita y consulta la documentación registral que necesitas para tus operaciones.">
      <TramitesPanel />
    </AdminPage>
  ),
});
